// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote_quote__1j3N9","wrapper":"Quote_wrapper__W_917","column":"Quote_column__9isXf","inner":"Quote_inner__XFd7L"};